import { DateTime } from 'luxon';
import { zones } from 'tzdata';
import deprecatedTimezones from './deprecated-timezones.json';
import timezones from './timezones.json';

const luxonValidTimezones = [
    ...new Set<string>(Object.keys(zones).filter((tz) => tz.includes('/') && DateTime.local().setZone(tz).isValid)),
];

export interface TimezoneItem {
    label: string;
    value: string;
    group?: string;
    keywords?: string[];
}
export const customTimezoneList: TimezoneItem[] = timezones;

export const timeZoneList = luxonValidTimezones
    .filter((tzName: string) => !deprecatedTimezones.includes(tzName))
    .map((tzName: string) => {
        const customTz = customTimezoneList.find((customTz) => customTz.value === tzName);
        return customTz || { label: tzName.replace(/_/g, ' ').replace(/\//, ': '), value: tzName };
    })
    .sort((a: { label: string }, b: { label: string }) => (a.label > b.label ? 1 : a.label < b.label ? -1 : 0));
